import { useTranslation } from 'react-i18next';

import ListboxWithCustomFooter from '../ListboxWithCustomFooter';

import styles from './index.module.scss';

const NoOptionsWithCustomFooter = () => {
  const { t } = useTranslation();

  return (
    <ListboxWithCustomFooter>
      <p className={styles.item}>{t('common.noOptions')}</p>
    </ListboxWithCustomFooter>
  );
};

export default NoOptionsWithCustomFooter;
